import { useTheme } from "@/app/theme"

/**
 * La marca, en sus dos formas.
 *
 * - `completo` — mascota + palabra "Alpaca IA". Dos archivos, uno por tema: la palabra
 *   usa el azul oscuro de marca (`#0B1220`), que es también el fondo oscuro
 *   recomendado, así que sobre él media marca desaparece. Se elige por el tema
 *   **resuelto**, no por la preferencia — con "sistema" hay que saber qué se está
 *   pintando de verdad.
 * - `icono` — solo la A con las orejas. Es lo que queda cuando la barra lateral se
 *   pliega, y **no necesita variante por tema**: es un gradiente sobre transparente y
 *   se lee igual sobre los dos fondos. Va en SVG (6,3 kB frente a 115 kB del PNG de
 *   512) porque a 32 px un PNG grande escalado se ve sucio y uno pequeño, borroso.
 */
export function Logo({
  className,
  variante = "completo",
}: {
  className?: string
  variante?: "completo" | "icono"
}) {
  const { resolved } = useTheme()

  if (variante === "icono") {
    return (
      <img
        src="/alpaca-ia-A.svg"
        alt="Alpaca IA"
        className={className}
        width={64}
        height={64}
      />
    )
  }

  const base = resolved === "dark" ? "alpaca-ia-logo-dark" : "alpaca-ia-logo-light"

  return (
    <img
      src={`/${base}.webp`}
      srcSet={`/${base}.webp 1x, /${base}@2x.webp 2x`}
      alt="Alpaca IA"
      className={className}
      // Reservar el espacio evita que el resto de la barra lateral salte cuando el
      // logo termina de cargar.
      width={480}
      height={139}
    />
  )
}
